// extracted by mini-css-extract-plugin
module.exports = {"delegators":"styles_delegators__2g2Eh"};